import { publicUrl } from "./publicUrl.js";

let loaderPromise = null;

export async function getConfiguredGLTFLoader() {
  if (loaderPromise) return loaderPromise;

  loaderPromise = (async () => {
    const [{ GLTFLoader }, { DRACOLoader }] = await Promise.all([
      import("three/examples/jsm/loaders/GLTFLoader.js"),
      import("three/examples/jsm/loaders/DRACOLoader.js"),
    ]);

    const loader = new GLTFLoader();
    const dracoLoader = new DRACOLoader();

    // Decoder files are copied into `public/draco/` by `scripts/prepare_assets.mjs`.
    dracoLoader.setDecoderPath(publicUrl("draco/"));
    dracoLoader.setDecoderConfig({ type: "wasm" });

    loader.setDRACOLoader(dracoLoader);
    return loader;
  })();

  return loaderPromise;
}

